import Analytics from '@monolith/legacy/services/analytics';

// Event names
enum MediaLibraryEventName {
  MediaLibraryOpened = 'Media Library Opened',
  MediaLibraryImport = 'Media Library Import',
  BrandVideoPlayed = 'Brand Video Played',
}

// Event origins
export enum MediaLibraryOrigin {
  ProductDetail = 'product_detail',
  ProductsList = 'products_list',
  ProductsImport = 'products_import',
  Other = 'other',
}

// Media Library Opened event properties
export interface MediaLibraryOpenedEventProperties {
  brand_id: number;
  origin: MediaLibraryOrigin;
}

// Media Library Import event properties
export interface MediaLibraryImportEventProperties {
  brand_id: number;
  file_count: number;
  total_size?: number;
}

// Brand Video Played event properties
export interface BrandVideoPlayedEventProperties {
  brand_uuid: string;
  video_id: string;
  display_context?: string;
}

export function trackMediaLibraryOpened(properties: MediaLibraryOpenedEventProperties): void {
  Analytics.track({
    name: MediaLibraryEventName.MediaLibraryOpened,
    properties
  });
}

export function trackMediaLibraryImport(properties: MediaLibraryImportEventProperties): void {
  Analytics.track({
    name: MediaLibraryEventName.MediaLibraryImport,
    properties
  });
}

export function trackBrandVideoPlayed(properties: BrandVideoPlayedEventProperties): void {
  Analytics.track({
    name: MediaLibraryEventName.BrandVideoPlayed,
    properties
  });
}
